import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

//Subclases
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.claseserv.codigoClaseServ}</td>
      <td className=''>{elemento.claseserv.descrClaseServ}</td>
      <td className=''>{elemento.codigoSubclaseServ}</td>
      <td className=''>{elemento.descrSubclaseServ}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfSubclase2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a25010501 = autorizacUA.findIndex( autorizac => autorizac === "25010501" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Subclases" btnNuevo={a25010501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '10%'}}>Cód Clase</th>
                <th className='' style={{width: '40%'}}>Descripción</th>
                <th className='' style={{width: '10%'}}>Cód Subclase</th>
                <th className='' style={{width: '40%'}}>Descripción</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfSubclase2
